export var Path;
(function (Path) {
    Path["CATEGORY"] = "category";
    Path["COLLECTION"] = "collection";
    Path["WEB_SOLUTION"] = "web-solution";
    Path["HOME"] = "";
    Path["SEARCH"] = "search-result";
    Path["SHARE"] = "share-app";
    Path["FINISH_SETUP"] = "finish-setup";
    Path["MANAGE_APPS"] = "manage-apps";
    Path["RECOMMENDATION"] = "recommendation";
    Path["DEVELOPER"] = "developer";
    Path["OPEN_APP_WITH_PARAMS"] = "open-app-with-params";
})(Path || (Path = {}));
export var Origin;
(function (Origin) {
    Origin["EDITOR"] = "editor";
    Origin["BIZMGR"] = "bizmgr";
    Origin["STANDALONE"] = "standalone";
})(Origin || (Origin = {}));
export var ReviewsSortBy;
(function (ReviewsSortBy) {
    ReviewsSortBy["MostRecent"] = "-publishedAt";
    ReviewsSortBy["MostHelpful"] = "-totalLikes";
    ReviewsSortBy["Rating"] = "-rating";
})(ReviewsSortBy || (ReviewsSortBy = {}));
export var AppPageMode;
(function (AppPageMode) {
    AppPageMode["PREVIEW"] = "preview";
    AppPageMode["TEST"] = "test";
})(AppPageMode || (AppPageMode = {}));
export var OriginQueryParam;
(function (OriginQueryParam) {
    OriginQueryParam["EDITOR"] = "editor_platform";
    OriginQueryParam["BIZMGR"] = "business_manager_platform";
    OriginQueryParam["STANDALONE"] = "stand_alone_platform";
    OriginQueryParam["ADI_DASHBOARD"] = "adi%20in%20bm";
})(OriginQueryParam || (OriginQueryParam = {}));
export var EditorType;
(function (EditorType) {
    EditorType["EDITOR"] = "EDITOR";
    EditorType["EDITORX"] = "EDITORX";
    EditorType["ADI"] = "ADI";
})(EditorType || (EditorType = {}));
export var MarketPermissions;
(function (MarketPermissions) {
    MarketPermissions["MANAGE_APPS"] = "app-market.manage-app";
    MarketPermissions["UPGRADE_APP"] = "app-market.upgrade-app";
    MarketPermissions["UPDATE_APP"] = "APP_MARKET.UPDATE_APP";
    MarketPermissions["INSTALL_APP"] = "APP_MARKET.INSTALL_APP";
    MarketPermissions["UNINSTALL_APPS"] = "APP_MARKET.UNINSTALL_APPS";
    MarketPermissions["DELETE_APP"] = "APP_MARKET.DELETE_APP";
    MarketPermissions["ADD_AGAIN"] = "APP_MARKET.ADD_AGAIN";
    MarketPermissions["OPEN_APP"] = "APP_MARKET.OPEN_APP";
})(MarketPermissions || (MarketPermissions = {}));
export var StatusCode;
(function (StatusCode) {
    StatusCode[StatusCode["NOT_FOUND"] = 404] = "NOT_FOUND";
})(StatusCode || (StatusCode = {}));
export var ErrorPageType;
(function (ErrorPageType) {
    ErrorPageType["INTERNAL_SERVER"] = "500";
    ErrorPageType["NOT_FOUND"] = "404";
    ErrorPageType["NOT_AVAILABLE_APP"] = "not-available-app";
})(ErrorPageType || (ErrorPageType = {}));
//# sourceMappingURL=marketplace-enums.js.map